<template>
    <base-layout
        :label-width="labelWidth"
        :text-align="textAlign"
        :is-require="isRequire"
        :label="label"
        :readOnly="readOnly"
        :value="showValue"
        :style-type="styleType"
        :is-dipatch="isDipatch"
        :is-dipatch-style="isDipatchStyle"
        :labelPaddingRight = "labelPaddingRight"
        >
        <el-cascader
            class="base-el-cascader"
            slot="control"
            :options="getOptions"
            @active-item-change="handleItemChange"
            v-model="inputValue"
            @change="handleChange">
        </el-cascader>
    </base-layout>
</template>

<script>
    import baseLayout from './base-layout.vue';
    import {handleEmitValue, cascader} from './../props-config';
    import * as API from './base-enum-remote';

    export default {
        name: 'base-cascader',
        components: {
            baseLayout
        },
        computed: {
            inputValue: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            },
            getOptions() {
                // 如果是拉去服务器下拉
                if (this.remote || this.apiName) {
                    return this.list
                }
                else {
                    return this.options 
                }
            },
        },
        props: {
            ...cascader,
            options: {
                type: Array,
                default: () => ([])
            },
            apiName: {
                type: String,
                default: ''
            },
            // 接受固定参数
            params: {
                type: Object,
                default: () => ({})
            },
            value: {
                type: Array,
                default: () => ([])
            },
            dataType: {
                type: String,
                default: ''
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            // 单机某个
            handleChange(val) {

            },
            handleEmitValue,
            // 动态加载次级数据
            handleItemChange(val) {

            },
            // 拉去固定参数的数据
            syncGetOptions(params) {
                return API.syncGetEnum(this.apiName, params)
                        .then(res => {
                            this.list = res;
                        })
            },
            init() {
                if (this.apiName) {
                    this.syncGetOptions(this.params)
                }

            }
        },
        data() {
            return {
                timer: null,
                list: []
            }
        }
    }
</script>

<style lang="scss" scoped>
    .base-el-cascader{
        width: 100%;
    }
</style>
